module.exports = __webpack_public_path__ + "media/images/img-secondcarrier-1-de37f148.jpg";